import { type Enum } from '../../utils/enums'

export const InstanceManagementCompanyStages = {
  NEW: 'New',
  ONBOARDING: 'Onboarding',
  ADOPTED: 'Adopted',
  ENGAGED: 'Engaged',
  BONDED: 'Bonded',
  RECONFIGURATION: 'Reconfiguration',
} as const

export type InstanceManagementCompanyStage = Enum<
  typeof InstanceManagementCompanyStages
>
